import { MainContainer } from "../../component/container";
import Kin from '../../assets/image/kin.jpg'
import BouncingIcon from "../../component/BouncingIcon";

import Kns from '../../assets/image/Loc4.gif'
import Ktg from '../../assets/image/ktg.gif'
import Ksi from '../../assets/image/SIDEBAR2.jpg'
import { useNavigate } from "react-router-dom";
import { Element, Link } from 'react-scroll';

export default function VisitCongo() {
    const navigate = useNavigate();

    const Section = ({ title, image, children }) => {
        const calculerMoitieLongueur = (texte) => (texte ? Math.floor(texte.length / 2) : 0);

        // Calculer la moitié de la longueur du titre
        const moitieLongueurTitre = calculerMoitieLongueur(title);
        return (
            <div className=' text-left  mt-3 flex justify-center '>
                <div className="flex flex-col text-left mt-10">
                    <div className='text-left font-extrabold text-lg text-[#87ceeb] relative inline-block'>
                        {title}
                        <span
                            className="absolute inset-0 bg-gradient-to-r h-1 top-8 text-left from-[#87ceeb] to-transparent flex items-left"
                            style={{ width: `calc(${moitieLongueurTitre}ch)` }}
                        ></span>


                    </div>
                    <div className="flex  mt-5">
                        <div className="flex flex-col sm:flex-row gap-5 sm:min-w-[450px]">
                            <img src={image} alt={title} className='' />
                            {children}
                        </div>
                    </div>

                </div>

            </div>

        )
    }

    return (
        <MainContainer>
            <div id='content' className="">
                <img src={Kin} alt="Kin" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">Visit Congo.</h1>
                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>

            <div className="2xl:px-80 xl:px-52 px-10 mt-24">
                <div className="text-center">
                    The Amero-Congo Relief Foundation, Inc ( The ACRFI ), is a non profit and charitable organization incorporated in the State of Florida, US and legally operating in Miami Florida, and in 3 States of the Democratic Republic of Congo (KATANGA, KASAI & KINSHASA States).
                </div>

                <div className="text-[#2E51A9] text-center font-bold mt-10">
                    [Coming soon: The ACRFI will organise trips to visit and assist orphans in the Congo DRC]
                </div>

                <div className="grid 3xl:grid-cols-3 xl:grid-cols-2 grid-cols-1 gap-5  mt-10">
                    <Section title={'THE ACRFI-KATANGA / CONGO (DRC)'} image={Ktg} >
                        <div className="flex items-left justify-left flex-col">
                            <span className="">2996 Lac Kipopo, Q.Gambela Ii</span>
                            <span className="">Commune Lubumbashi</span>
                            <span className="">Katanga, DRC</span>

                            <span className="mt-5">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 243-99-873-7019</span>
                        </div>
                    </Section>
                    <Section title={'THE ACRFI-KASAI / CONGO (DRC)'} image={Ksi} >
                        <div className="flex items-left justify-left flex-col">
                            <span className="">Theresienne sisters</span>
                            <span className="">Q Bonzola / Mbuji Mayi</span>
                            <span className="">Kasai oriental</span>

                            <span className="mt-5">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 243-99-927-0737</span>
                        </div>
                    </Section>
                    <Section title={'THE ACRFI-KINSHASA / CONGO (DRC)'} image={Kns} >
                        <div className="flex items-left justify-left flex-col">
                            <span className="">17, Avenue Mbandaka, Q/Kingabwa</span>
                            <span className="">C/Llimete-Kinshasa</span>
                            <span className="">Dem. rep. of Congo</span>

                            <span className="mt-5">E-mail: admin@theacrfi.org</span>
                            <span className="">Tel: 243-99-812-7675</span>
                        </div>
                    </Section>
                </div>

                <div className="mt-12">
                    For your gift to save a life, please click below and securely donate using PayPal; or go to <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Donate') }}> donate today </span>and choose a different way to send your donations. As always,thank you in advance for your caring heart!
                </div>
            </div>
        </MainContainer>
    )
}